import { useData } from "@hooks/useData";
import { iReportProPublication, ReportProPublication } from "@models/ReportProPublication";
import http from '@core/fetch';
import { components } from "@apiSchema";
import apiConfig from "@apiConfig";

const REQUEST_TYPE: keyof typeof apiConfig = 'get menu publications by tag';
type Response = components["schemas"]["ReportProPublicationClient"][];

async function getMenuPublications(): Promise<iReportProPublication[]> {
    const response: Response = await http.get(REQUEST_TYPE);
    return (response || []).map(apiModel => new ReportProPublication({ apiModel }));
}

export function useMenuPublications() {
    return useData([], getMenuPublications);
}
